import { Video } from "../../../../src/components/Video";
import * as React from 'react';
export default {
  Video,
  React
};